<template>
  <article class="vacancy">
    <div class="container">
      <HeroesMainHero
        v-if="hero && (hero.title?.value || hero.body?.value)"
        :main-hero="{
          intro: {
            icon: hero.icon ?? null,
            title: hero.title ?? null,
            body: hero.body ?? null,
          },
          img: hero.image,
          article: hero.links,
        }" />
      <section class="vacancy__details content-block-mid">
        <h1 v-if="title && title.value" v-bind="useEpiAttrs(title)">{{ title.value }}</h1>
        <BlocksWerkenbijContentArea v-if="body && body.value" :content="body" />
        <BlocksWerkenbijContentArea v-if="body2 && body2.value" :content="body2" />
      </section>
      <footer class="vacancy__footer content-block-mid">
        <div class="buttons">
          <ButtonsBaseButton
            v-if="applyButton?.text && applyButton.link?.value"
            bg-color="oker"
            :text="applyButton.text"
            :link="applyButton.link.value"
            icon-right="arrow-right"
            class="mb-2" />
          <ButtonsSocialsButton
            v-if="shareSocials && shareSocials.length"
            :text="{ propertyName: '', value: 'Deze vacature delen' }"
            :socials="shareSocials"
            class="mb-2" />
        </div>
      </footer>
      <aside class="vacancy__aside content-block-side">
        <ButtonsBaseButton
          v-if="applyButton?.text && applyButton.link?.value"
          bg-color="oker"
          :text="applyButton?.text"
          :link="applyButton.link.value"
          icon-right="arrow-right"
          class="mb-2" />
        <BlocksWerkenbijContentArea v-if="rightColumn?.value?.content" :content="rightColumn" />
      </aside>
    </div>
  </article>
</template>

<script lang="ts" setup>
import type { ContentResponseModel, JobPageResponseModel } from '@api';

const props = defineProps<{ data: ContentResponseModel }>();
const { applyButton, body, hero, rightColumn, shareSocials, body2, title } = props.data
  .content as JobPageResponseModel;
</script>

<style lang="scss" scoped>
.vacancy {
  .container {
    grid-template-rows: repeat(4, auto);

    .hero {
      grid-row: 1 / 2;
    }
  }

  &__details {
    grid-row: 2 / 3;
  }

  &__footer {
    display: flex;
    flex-direction: column;
    grid-row: 3 / 4;

    .buttons {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      order: 2;

      @include media-breakpoint-up(md) {
        justify-content: flex-start;

        .btn {
          margin-right: px(24);
        }
      }
    }
  }

  &__aside {
    grid-row: 4 / 5;

    > .btn {
      display: none;
    }

    @include media-breakpoint-up(xl) {
      grid-row: 2 / 3;

      > .btn {
        display: inline-flex;
      }
    }
  }
}
</style>
